var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlay = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 12 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.281 5.719c.447.275.719.76.719 1.281 0 .522-.272 1.006-.719 1.253l-8.999 5.5a1.44 1.44 0 0 1-1.516.056A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 2.282.22z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;